
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 48 32","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0v3h48V0H0zm0 14v3h48v-3H0zm0 14v3h48v-3H0z","fill":"#191919"}})])
      }
    
      }
    